import React from "react";

const Footer = () => (
  <footer className="bg-light p-3 text-center">
    <div className="logo" />
    <p>
      IoT Car Parking - &copy; <a href="https://sensational.systems">Sensational Systems</a> {(new Date().getFullYear())}
    </p>
  </footer>
);

export default Footer;
